import arrayInsert from './arrayInsert';

export function stateArrayAdd<T>(object: T) {
  return (prevState: T[]) => arrayInsert(prevState, object);
}

export default stateArrayAdd;
